import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDate(date?: string | null, locale = "ru") {
  if (!date) {
    return date;
  }

  const dateObject = dayjs.utc(date);
  if (!dateObject.isValid()) {
    return "";
  }

  switch (locale) {
    case "ru":
      return dateObject.local().format("DD.MM.YYYY");
    default:
      return dateObject.toISOString();
  }
}

export function formatDateTime(date?: string | null): string {
  if (!date) {
    return "";
  }
  const dateObject = dayjs.utc(date);
  if (!dateObject.isValid()) {
    return "";
  }
  return dateObject.local().format("DD.MM.YYYY HH:mm");
}

const moscowDateFormatter = new Intl.DateTimeFormat("ru-RU", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  timeZone: "Europe/Moscow",
});

const moscowTimeFormatter = new Intl.DateTimeFormat("ru-RU", {
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Moscow",
});

const isValidDate = (d: Date) => !Number.isNaN(d.getTime());

export function formatMoscowDatetime(date?: string | Date | null): string {
  if (!date) return "";
  const d = new Date(date);
  if (!isValidDate(d)) return "";
  return `${moscowDateFormatter.format(d)} ${moscowTimeFormatter.format(d)} МСК`;
}

export function formatMoscowTime(date?: string | Date | null): string {
  if (!date) return "";
  const d = new Date(date);
  if (!isValidDate(d)) return "";
  return moscowTimeFormatter.format(d);
}

export function formatDatetime(date?: string | Date | null): string {
  if (!date) return "";
  const d = new Date(date);
  if (!isValidDate(d)) return "";
  return `${moscowDateFormatter.format(d)} ${moscowTimeFormatter.format(d)}`;
}

export function toApiDate(date?: string | null): string {
  if (!date) return "";
  const d = dayjs(date);
  if (!d.isValid()) return "";
  return d.format("YYYY-MM-DD");
}

export function toDayjsDate(date?: string | null) {
  return dayjs(date);
}

export function getLatestIsoDate(
  ...dates: (string | null | undefined)[]
): string | undefined {
  const validDates = dates.filter((date): date is string => {
    if (!date) return false;
    return dayjs.utc(date).isValid();
  });

  if (validDates.length === 0) {
    return undefined;
  }

  return validDates.reduce((latest, current) =>
    dayjs.utc(current).isAfter(dayjs.utc(latest)) ? current : latest,
  );
}
